<mat-form-field appearance="fill">
  <mat-label>{{ label }}</mat-label>
  <input matInput
         type="text" 
  [value]="formattedTime"
  (input)="onTimeChange($event)" />
</mat-form-field>
